// ============================================================
// OLD REFUND SHIPMENT (commented out)
// ============================================================
// import React, { useEffect, useState } from "react";
// import classes from "./shipment.module.css";
// import { CustomSelect } from "../../../../component/customSelect/CustomSelect";
// import { shipmentDetailTableColumnsConfig } from "./shipmentDetailTableColumnsConfig";
// import { Table } from "../../../../component/table/Table";
//
// const optionData = [
//   { id: "0", label: "Pending" },
//   { id: "1", label: "In Process" },
//   { id: "2", label: "Shipped" },
//   { id: "10", label: "Delivered" },
// ];
//
// export const Shipment = ({ shipment, onChange }) => {
//   const [columnDefs, setColumnDefs] = useState([]);
//
//   const handleChange = (id) => {
//     onChange({ shipment_id: shipment.shipment_id, status: id });
//   };
//
//   useEffect(() => {
//     if (shipment?.category) {
//       const hasVrp = shipment.category === "VRP";
//       setColumnDefs(shipmentDetailTableColumnsConfig.shipmentDetail(null, null, hasVrp));
//     }
//   }, [shipment?.category]);
//
//   return (
//     <div className={classes.box}>
//       <div className={classes.box__shipment}>
//         <div className={classes.box__shipment__left}>
//           <h1 className={classes.box__shipment__head}>{shipment?.title}</h1>
//           <CustomSelect label="Change Status" options={optionData} onChange={(id) => handleChange(id)} value={shipment.status_id} />
//         </div>
//         <div className={classes.box__shipment__btns}>
//           <button className={classes.box__shipment__download}>Download Invoice</button>
//         </div>
//       </div>
//       <input type="checkbox" id={shipment.id} className={classes.box__shipment__input} />
//       <label htmlFor={shipment.id} className={classes.box_shipment__label}></label>
//       <div className={classes.box__shipment__table}>
//         <Table data={shipment?.items} columns={columnDefs} />
//       </div>
//     </div>
//   );
// };
// ============================================================

import { useMemo, useCallback } from "react";
import classes from "./shipment.module.css";

import { CustomSelect } from "../../../../component/customSelect/CustomSelect";
import { shipmentDetailTableColumnsConfig } from "./shipmentDetailTableColumnsConfig";
import { Table } from "../../../../component/table/Table";
import { ShipmentStatusBadge } from "../RefundDetailPage";
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import { useLazyDownloadInvoiceQuery } from "../../../../services/orderDetailApiSlice";

export const Shipment = ({ shipment, orderId, onChange }) => {
  const [triggerDownload, { isFetching }] = useLazyDownloadInvoiceQuery();

  const hasInvoice = useMemo(() => {
    if (shipment?.invoice_url) return true;
    return shipment?.items?.some((item) => item?.invoice_url);
  }, [shipment]);

  const columnDefs = useMemo(() => {
    if (!shipment?.category) return [];
    const hasVrp = shipment.category === "VRP";
    return shipmentDetailTableColumnsConfig.shipmentDetail(null, null, hasVrp);
  }, [shipment?.category]);

  const handleStatusSelect = useCallback(
    (statusId) => {
      if (!statusId || statusId === shipment.status_id) return;

      const selectedStatus = shipment.shipment_valid_status.find(
        (s) => Number(s.id) === Number(statusId),
      );

      onChange({
        shipment_id: shipment.shipment_id,
        status: Number(statusId),
        statusLabel: selectedStatus?.label,
        currentStatus: shipment.status,
      });
    },
    [shipment, onChange],
  );

  const handleDownloadInvoice = async () => {
    try {
      const res = await triggerDownload({
        orderId,
        shipment_id: shipment.shipment_id,
      }).unwrap();

      const url = res?.data?.invoice_url;
      if (!url) return;

      window.open(url, "_blank");
    } catch (err) {
      console.error("Download failed", err);
    }
  };

  const validStatuses = shipment?.shipment_valid_status || [];
  const hasMultipleStatuses = validStatuses.length > 1;

  return (
    <div className={classes.box}>
      {/* HEADER */}
      <div className={classes.header}>
        <h2 className={classes.title}>{shipment?.title}</h2>

        <div className={classes.headerBadges}>
          <ShipmentStatusBadge status={shipment.status} />
        </div>
      </div>

      {/* ACTIONS */}
      <div className={classes.actions}>
        {hasMultipleStatuses && (
          <div className={classes.actions__wrapper}>
            <CustomSelect
              placeholder="Change Status"
              options={validStatuses}
              value={shipment.status_id}
              onChange={handleStatusSelect}
            />
          </div>
        )}

        {hasInvoice && (
          <button
            className={classes.downloadBtn}
            onClick={handleDownloadInvoice}
            disabled={isFetching}
          >
            <ArrowDownTrayIcon className={classes.downloadBtn__icon} />
            <span>{isFetching ? "Downloading..." : "Download Invoice"}</span>
          </button>
        )}
      </div>

      <Table data={shipment?.items || []} columns={columnDefs} />
    </div>
  );
};
